import { Modal } from 'framework/ui/ui-builder';
import { Stack, Typography, Box } from '@mui/material';
import { Button } from 'framework/ui/mui-builder';
import React from 'react';

interface ContractRenewalConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  endDate?: string;
  onConfirm: () => void;
}

const ContractRenewalConfirmModal = ({ isOpen, onClose, endDate, onConfirm }: ContractRenewalConfirmModalProps) => (
  <Modal isOpen={isOpen} onToggle={onClose} title="Attention">
    <Stack spacing={2}>
      <Typography>
        The project will end on {endDate}, the team will be deallocated. This action may cause a work gap if renewal is
        later needed. Confirm your decision.
      </Typography>

      <Box gap={1} display="flex" flexDirection="row" justifyContent="flex-end">
        <Button variant="contained" onClick={onConfirm}>
          Confirm
        </Button>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
      </Box>
    </Stack>
  </Modal>
);

export default ContractRenewalConfirmModal;
